import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-my-tasks',
  imports: [],
  template: ``,
  styles: ``,
})
export class MyTasksComponent extends BaseComponent {}
